<template>
  <div class="checkin-step2">
    <h4>乘机人信息</h4>
    <div class="loading" v-if="loading">
      <a-spin tip="正在加载乘机人信息..." />
    </div>
    <components
      v-if="!loading"
      v-bind:is="compName"
      :checkinList="checkinList"
      @selectTrip="selectTrip"
    ></components>
    <div class="checkin-accept" v-if="agreeList.length">
      <a-checkbox @change="onChange"></a-checkbox>
      <span>
        我已阅读并接受
        <router-link
          v-for="(item, index) in agreeList"
          :to="item.url"
          :key="index"
          target="_blank"
        >{{ item.name }}{{ `${index === (agreeList.length - 1) ? '!' : index === (agreeList.length - 2) ? '和' : '、'}` }}</router-link>
      </span>
    </div>
    <div class="rule-wrap">
      <rule></rule>
    </div>
    <div class="next-step">
      <a-button type="primary" class="next-step-btn" size="large" @click="nextStep">下一步</a-button>
    </div>
  </div>
</template>
<script>
import { checkinTrip } from '@/apis/checkin'
import CheckInList from '@/components/checkin/selectCheckin'
import Rule from '@/components/checkin/rule'
import moment from 'moment'

export default {
  props: {
    stepData: { type: Object },
    cmsData: Object
  },
  data () {
    return {
      compName: '',
      checkinList: [],
      isSelect: false,
      selectIndex: -1,
      flightData: {}, // 勾选的航班信息
      agree: false,
      tourIndex: '',
      loading: true
    }
  },
  created () {
    this.getFlightData()
  },
  computed: {
    agreeList () {
      const { cmsData } = this
      return cmsData?.checkinAgreement?.list || []
    }
  },
  methods: {
    nextStep () {
      if (this.isSelect && (this.agree || !this.agreeList.length)) {
        const stepData = this.flightData
        this.$emit('callback', 3, stepData, { tourIndex: this.tourIndex })
        window.__MICRO_ROOT__?.api?.track?.('checkin_check')
      } else if (!this.isSelect) {
        this.$message.error('请勾选行程')
      } else {
        this.$message.error('请阅读并同意协议')
      }
    },
    async getFlightData () {
      const data = {
        ...this.stepData
      }
      if (data.certType === 'ID_CARD') {
        data.certType = 'NI'
      }

      try {
        const result = await checkinTrip({
          ...data,
          slideCaptcha: new Date().getTime()
        })
        this.loading = false
        result.forEach((item, index) => {
          if (item.depTime) {
            let timeFormat = moment(item.depTime).format()
            item.depTimeFormat = timeFormat.split('T')[1].slice(0, 5)
            item.depDateFormat = timeFormat.split('T')[0]
          } else {
            item.depTimeFormat = ''
            item.depDateFormat = ''
          }
          if (item.arrTime) {
            item.arrTimeFormat = moment(item.arrTime).format().split('T')[1].slice(0, 5)
          } else {
            item.arrTimeFormat = ''
          }

          if (item.status === 'OPEN FOR USE') {
            item.statusText = '可值机'
          } else {
            if (item.status === 'CHECKED IN') {
              item.statusText = '已值机'
            } else {
              item.statusText = '不可值机'
            }
            item.disabled = true
          }
          this.checkinList.push(item)
        })
        this.compName = 'CheckInList'
      } catch (err) {
        this.loading = false
        this.$message.error(err.message)
        this.$emit('callback', 1)
      }
    },
    selectTrip (index) {
      this.isSelect = true
      this.selectIndex = index
      let flight = this.checkinList[index]
      this.flightData = {
        airline: flight.airline,
        arrCode: flight.arrCode,
        cabin: flight.cabin,
        certNo: flight.certNo,
        depCode: flight.depCode,
        depTime: flight.depTime,
        flightNo: flight.flightNo,
        ticketNo: flight.ticketNo
      }
      this.tourIndex = flight.tourIndex
    },
    onChange (e) {
      this.agree = e.target.checked
    }
  },
  components: {
    CheckInList,
    Rule
  }
}
</script>

<style lang="less" scoped>
.checkin-step2 {
  h4 {
    margin-bottom: 15px;
    font-size: 24px;
    line-height: 32px;
    font-weight: bold;
  }
  .loading {
    color: #333;
    text-align: center;
    font-size: 18px;
    padding-bottom: 20px;
  }

  .checkin-accept {
    padding-left: 30px;
    padding-top: 10px;
    padding-bottom: 10px;
    line-height: 24px;
    color: #000;
    a {
      color: @primary-color;
    }
  }
  .rule-wrap {
    margin-top: 50px;
  }
  .next-step {
    padding-top: 50px;
    padding-bottom: 30px;
    text-align: center;
    .next-step-btn {
      width: 180px;
    }
  }
}
@media only screen and (max-width: 768px) {
  .checkin-step2 {
    h4 {
      margin-left: 10px;
    }
    .checkin-accept {
      padding-left: 10px;
      font-size: 14px;
      line-height: 22px;
    }
    .rule-wrap {
      width: 94%;
      margin: 0 auto;
      margin-top: 30px;
    }
  }
}
</style>
